import * as puntcity from './PlacesAutocomplete.styles.puntcity';
import * as puntgenie from './PlacesAutocomplete.styles.puntgenie';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  puntcity,
  puntgenie,
};
